import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Search, Heart, Plus, BarChart3, User } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const UnifiedMobileFooter: React.FC = () => {
  const location = useLocation();
  const { user } = useAuth();

  // Determine the correct routes based on user role
  const getNavItems = () => {
    return [
      { label: 'Find', icon: Search, to: '/directory' },
      { label: 'Favourites', icon: Heart, to: '/favourites' },
      { label: 'Log', icon: Plus, to: '/log', center: true },
      { label: 'Progress', icon: BarChart3, to: '/progress' },
      { label: 'Profile', icon: User, to: '/profile' },
    ];
  };

  const navItems = getNavItems();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg md:hidden">
      <div className="flex justify-around items-center px-2 py-2">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.to;
          
          if (item.center) {
            return (
              <Link
                key={item.label}
                to={item.to}
                className="relative flex flex-col items-center justify-center -mt-6"
              >
                <div className="rounded-full bg-sauna-orange text-white p-4 shadow-lg border-4 border-white hover:scale-105 transition-transform">
                  <Icon className="w-6 h-6" />
                </div>
                <span className="text-xs mt-1 font-medium text-gray-500">{item.label}</span>
              </Link>
            );
          }
          
          return (
            <Link
              key={item.label}
              to={item.to}
              className={`flex flex-col items-center py-1 px-2 transition-colors ${
                isActive 
                  ? 'text-sauna-orange' 
                  : 'text-gray-500 hover:text-sauna-orange'
              }`}
            >
              <Icon className="w-5 h-5 mb-1" />
              <span className="text-xs font-medium">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default UnifiedMobileFooter; 